import React from 'react';

interface CornerHandleModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CornerHandleModal: React.FC<CornerHandleModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal-content" style={{ maxWidth: '500px' }}>
        <div className="modal-header" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <h3 style={{ margin: 0, textAlign: 'center', width: '100%' }}>Informacja o stronie klamki</h3>
        </div>
        <div className="modal-body" style={{ padding: '20px' }}>
          <p style={{ fontSize: '16px', lineHeight: '1.5', marginBottom: '20px' }}>
            Standardowo klamka znajduje się na większej szybie.
          </p>
        </div>
        <div className="modal-buttons" style={{ padding: '0 20px 20px', textAlign: 'center' }}>
          <button 
            className="btn btn-primary" 
            onClick={onClose}
            style={{ 
              padding: '10px 30px', 
              fontSize: '16px',
              backgroundColor: 'var(--accent)',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default CornerHandleModal;
